const HF_BASE = 'http://www.hockeyfans.ch';
const CLUBLOGO = 'https://base.v1.hockeyfans.ch/ci_images/clublogo/';
const HF_ARCHIV = 'https://archive.v1.hockeyfans.ch';
export const LOCALE = 'de';

const COMMON_UTIL = {
	PARAM_BOTH: 'both', // see ch.hockeyfans.core.parameter.HA#BOTH
	links: {
		gameLink(gameId: string): string {
			return `${HF_BASE}/spiel/telegramm/${gameId}`;
		},
		playerPortrait(playerId: string): string {
			return `${HF_ARCHIV}/spieler/${playerId}/portrait.jpg`;
		},
		playerPictures(playerId: string): string {
			return `${HF_ARCHIV}/bilder/galleria.php?spielerId=${playerId}&format=json`;
		},
	},
	paths: {
		clubLogoPath(teamId: string): string {
			return `${CLUBLOGO}/${teamId}.png`;
		},
		clubLogoAltPath(teamId: string): string {
			return `${CLUBLOGO}/${teamId}.gif`;
		}
	}
};

export function toArray<T>(object: Record<string, T>): T[] {
	return Object.keys(object).map(key => object[key]);
}

export function zeroPad(num: number, places: number): number | string {
  const zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join('0') + num;
}

export default COMMON_UTIL;
